import paths from "routes/paths";

const POST_LOGIN_REDIRECT_KEY = "postLoginRedirectPath";

const isUnsafePath = (path) =>
  path.startsWith("http://") ||
  path.startsWith("https://") ||
  path.startsWith("//");

const isAuthPath = (pathname) => pathname.startsWith("/auth");

const isBlockedPath = (pathname) =>
  [
    paths.simpleLogin,
    paths.simpleLogout,
    paths.simpleSessionExpired,
    paths.cardLogin,
    paths.cardLogout,
  ].includes(pathname);

export const getCurrentAppPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const normalizeRedirectPath = (rawPath) => {
  if (typeof rawPath !== "string") return "/";

  const trimmed = rawPath.trim();
  if (!trimmed || isUnsafePath(trimmed)) return "/";

  const normalized = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  const [pathname] = normalized.split(/[?#]/);

  if (!pathname || isAuthPath(pathname) || isBlockedPath(pathname)) return "/";

  return normalized;
};

export const savePostLoginRedirect = (path = getCurrentAppPath()) => {
  const target = normalizeRedirectPath(path);
  localStorage.setItem(POST_LOGIN_REDIRECT_KEY, target);
};

export const clearPostLoginRedirect = () => {
  localStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
};

export const consumePostLoginRedirect = (fallbackPath = "/") => {
  const storedPath = localStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  clearPostLoginRedirect();

  const normalizedStoredPath = normalizeRedirectPath(storedPath || "");
  if (normalizedStoredPath !== "/") return normalizedStoredPath;

  return normalizeRedirectPath(fallbackPath);
};

export const resolvePostLoginRedirect = (location, fallbackPath = "/") => {
  const fromStatePath = location?.state?.from
    ? `${location.state.from.pathname || ""}${location.state.from.search || ""}${location.state.from.hash || ""}`
    : "";

  const queryPath = new URLSearchParams(location?.search || "").get("next") || "";

  const normalizedFromStatePath = normalizeRedirectPath(fromStatePath);
  if (normalizedFromStatePath !== "/") {
    clearPostLoginRedirect();
    return normalizedFromStatePath;
  }

  const normalizedQueryPath = normalizeRedirectPath(queryPath);
  if (normalizedQueryPath !== "/") {
    clearPostLoginRedirect();
    return normalizedQueryPath;
  }

  return consumePostLoginRedirect(fallbackPath);
};
